<template>
  <div class="hello">

   <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      background="#ababab"
      img-width="1024"
      img-height="200"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Text slides with image -->

        <b-carousel-slide class="video-slide"
          img-src="../assets/img/gallery/image-1.jpg"
          id="slide1"
        >
        </b-carousel-slide>


<!--       <a v-b-modal.video-1>
        <b-carousel-slide
          img-src="../assets/img/slide-1.jpg"
        >
          <img src="../assets/img/play.svg" class="play" />
        </b-carousel-slide>
      </a> -->

      <!-- <b-carousel-slide
        img-src="../assets/img/slide-1.jpg"
      ></b-carousel-slide> -->
    </b-carousel>

    <b-modal id="video-1" centered hide-footer busy="true" modalClass="ww-video-modal">
      <template v-slot:default="">
        <b-container class="">
          <b-row>
            <b-col>
              <b-embed
                type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/embed/uCVbjO8GvVY?&autoplay=1&rel=0"
                allowfullscreen
                allow="autoplay"
              ></b-embed>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <b-container class="ww-section">
      <b-row>
        <b-col>
          <h1>Design gallery</h1>

          <p class="subhead">From vintage to modern styles, there's a design ready to refresh the look of any space. <br class="d-none d-md-block">Browse the design gallery to discover your favorite looks.</p>
        </b-col>
      </b-row>
    </b-container>

    <b-container-fluid class="ww-section-fluid gallery-container">
      <b-row>
        <b-col col cols="12" lg="8" class="image">
          <b-img src="../assets/img/gallery/image-2-v2.jpg" fluid></b-img>
        </b-col>
        <b-col col cols="12" lg="4" class="text">
          <div>
            <a href="/designs?sku=W7008" style="color: black; text-decoration: none;">
              <h4>Torrone Marble</h4>
              <h5>W7008</h5>
            </a>
            <p>In this bathroom, a large-format, marble-inspired shower wall provides an understated elegance set against the warmth of other nature-rich surfaces.</p>
          </div>
        </b-col>
      </b-row>
    </b-container-fluid>

    <b-container-fluid class="ww-section-fluid gallery-container">
      <b-row>
        <b-col col cols="12" lg="8" order="1" order-lg="2" class="image">
          <b-img src="../assets/img/gallery/image-3.jpg" fluid></b-img>
        </b-col>
        <b-col col cols="12" lg="4" order="2" order-lg="1" class="text">
          <div>
            <a href="/designs?sku=W7014" style="color: black; text-decoration: none;">
              <h4>Norwegian Elm</h4>
              <h5>W7015</h5>
            </a>
            <p>A clean slate awaits in this European-inspired bathroom featuring a contemporary shower wall dressed in nature’s beauty.</p>
          </div>
        </b-col>
      </b-row>
    </b-container-fluid>

    <b-container-fluid class="ww-section-fluid gallery-container">
      <b-row>
        <b-col col cols="12" lg="8" class="image">
          <b-img src="../assets/img/gallery/image-4.jpg" fluid></b-img>
        </b-col>
        <b-col col cols="12" lg="4" class="text">
          <div>
            <a href="/designs?sku=W7019" style="color: black; text-decoration: none;">
              <h4>Marmafino</h4>
              <h5>W7019</h5>
            </a>
            <p>Granite-inspired shower walls with coordinating neutral surfaces turns traditional into timeless, ushering you in to a calm, inviting oasis.</p>
          </div>
        </b-col>
      </b-row>
    </b-container-fluid>

    <!--
    <b-container-fluid class="ww-section-fluid gallery-container">
      <b-row>
        <b-col col cols="12" lg="8" order="1" order-lg="2" class="image">
          <b-img src="../assets/img/product-images/W7028-add-1.jpg" fluid></b-img>
        </b-col>
        <b-col col cols="12" lg="4" order="2" order-lg="1" class="text">
          <div style="width: 100%;">
            <a href="/designs?sku=W7028" style="display: block; width: 100%; color: black; text-decoration: none;">
              <h4>Cosenza</h4>
              <h5>W7028</h5>
              <br /><br />
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container-fluid>

    <b-container-fluid class="ww-section-fluid gallery-container">
      <b-row>
        <b-col col cols="12" lg="8" class="image">
          <b-img src="../assets/img/product-images/W7041-add-2.jpg" fluid></b-img>
        </b-col>
        <b-col col cols="12" lg="4" class="text">
          <div style="width: 100%;">
            <a href="/designs?sku=W7041" style="display: block; width: 100%; color: black; text-decoration: none;">
              <h4>Arezzo</h4>
              <h5>W7041</h5>
              <br /><br />
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container-fluid>

    <b-container-fluid class="ww-section-fluid gallery-container">
      <b-row>
        <b-col col cols="12" lg="8" order="1" order-lg="2" class="image">
          <b-img src="../assets/img/product-images/W7036-add-1.jpg" fluid></b-img>
        </b-col>
        <b-col col cols="12" lg="4" order="2" order-lg="1" class="text">
          <div style="width: 100%;">
            <a href="/designs?sku=W7036" style="display: block; width: 100%; color: black; text-decoration: none;">
              <h4>Calacatta Statuario</h4>
              <h5>W7036</h5>
              <br /><br />
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container-fluid>

    <b-container-fluid class="ww-section-fluid gallery-container">
      <b-row>
        <b-col col cols="12" lg="8" class="image">
          <b-img src="../assets/img/product-images/W7042-add-2.jpg" fluid></b-img>
        </b-col>
        <b-col col cols="12" lg="4" class="text">
          <div style="width: 100%;">
            <a href="/designs?sku=W7042" style="display: block; width: 100%; color: black; text-decoration: none;">
              <h4>Legacy Ash</h4>
              <h5>W7042</h5>
              <br /><br />
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container-fluid>

    <b-container-fluid class="ww-section-fluid gallery-container">
      <b-row>
        <b-col col cols="12" lg="8" order="1" order-lg="2" class="image">
          <b-img src="../assets/img/product-images/W7027-add-1.jpg" fluid></b-img>
        </b-col>
        <b-col col cols="12" lg="4" order="2" order-lg="1" class="text">
          <div style="width: 100%;">
            <a href="/designs?sku=W7027" style="display: block; width: 100%; color: black; text-decoration: none;">
              <h4>Tahiti Sands</h4>
              <h5>W7027</h5>
              <br /><br />
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container-fluid>

    <b-container-fluid class="ww-section-fluid gallery-container">
      <b-row>
        <b-col col cols="12" lg="8" class="image">
          <b-img src="../assets/img/product-images/W7001-add-1.jpg" fluid></b-img>
        </b-col>
        <b-col col cols="12" lg="4" class="text">
          <div style="width: 100%;">
            <a href="/designs?sku=W7001" style="display: block; width: 100%; color: black; text-decoration: none;">
              <h4>Aria White</h4>
              <h5>W7001</h5>
              <br /><br />
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container-fluid>
  -->

  </div>
</template>

<script>
export default {
  name: 'Gallery',
  props: {
    msg: String
  },

  data: function () {
    return {
      videoPlay1: false
    }
  },

  methods: {
    swapSlide(slide) {
      this['videoPlay' + slide] = true;
      //jQuery('#slide1').hide();
    }
  },

  mounted () {
    window.jQuery(document).ready(function(){
      window.jQuery('.image').hover(
       function(){ window.jQuery(this).find('.overlay').addClass('hover') },
       function(){ window.jQuery(this).find('.overlay').removeClass('hover') },
      );
    });

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.feature-table {
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid black;

  .header {
    .col-md-4 {
      border-right: 1px solid black;

      &.copy {
        padding-top: 80px;

        @media(max-width: 768px) {
          padding-top: 180px;
        }
      }

      &.header {
        padding-top: 40px;
        font-family: 'Montserrat', sans-serif;
        font-weight: 800;
        text-transform: uppercase;

        @media(max-width: 768px) {
          padding-top: 200px;
        }

        span {
          display: block;
          @media(max-width: 768px) {
            position: absolute;
            top: 50%;
            left: 50%;
            transform:  translateX(-50%) translateY(-50%) rotate(-90deg);
            transform-orign: top;
            width: 200px;
          }
        }
      }
    }
  }

  .data {
    .col-md-4 {
      padding: 20px;
      border-right: 1px solid black;

      &:first-child {
        font-family: 'Montserrat', sans-serif;
        text-align: left;
        text-transform: uppercase;
      }
    }

    .check {
      width: 30px;
      height: auto;
    }
  }

  .shade {
    background-color: #FAFAFA;
  }

}


.icon-section {
  text-align: left;

  .row {
    margin-bottom: 20px;
  }

  .icon {
    flex-grow: 0;

    img {
      max-width: 60px;
      height: auto;
    }

  }

  .text {
    flex-grow: 1;
  }

}

.overlay {
  background-color: rgba(0,0,0,.5);
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
  transition: 0.3s;
  font-family: 'Montserrat', sans-serif;

  span {
    display: block;

    &.name {
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  &.hover {
    opacity: 1;
  }
}

.gallery-container {
  .row {
    .col {
      padding: 0;
    }

    .text {
      display: flex;
      align-items: center;

      p {
        padding: 1rem 3rem 3rem;
      }
    }

  }
}


h4 {
  margin: 40px 0 4px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
